import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useConsent } from "../contexts/ConsentContext";
import { useLanguage } from "../contexts/LanguageContext";
import { consentCopy } from "../data/privacy";

export default function CookieConsentBanner() {
  const { language } = useLanguage();
  const {
    hasDecision,
    preferencesOpen,
    acceptAll,
    rejectAll,
    openPreferences,
  } = useConsent();
  const rejectButtonRef = useRef(null);
  const copy = consentCopy[language] || consentCopy.it;

  useEffect(() => {
    if (!hasDecision) rejectButtonRef.current?.focus();
  }, [hasDecision]);

  if (hasDecision || preferencesOpen) return null;

  return (
    <>
      <div className="cookie-consent-shade" aria-hidden="true" />
      <section
        className="cookie-consent-banner"
        role="dialog"
        aria-modal="false"
        aria-labelledby="cookie-consent-title"
        data-consent-ui
      >
        <div className="cookie-consent-grid">
          <div className="cookie-consent-copy">
            <div className="cookie-consent-title-row">
              <h2 id="cookie-consent-title">{copy.bannerTitle}</h2>
              <button
                type="button"
                className="cookie-consent-close"
                onClick={() => rejectAll(language)}
                aria-label={copy.rejectClose}
                title={copy.rejectClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <p>
              {copy.bannerText}{" "}
              <Link className="cookie-consent-policy-link" to={`/${language}/cookies`}>
                {copy.policyLink}
              </Link>
            </p>
          </div>

          <div className="cookie-consent-actions">
            <button
              ref={rejectButtonRef}
              type="button"
              onClick={() => rejectAll(language)}
            >
              {copy.reject}
            </button>
            <button type="button" onClick={openPreferences}>
              {copy.customise}
            </button>
            <button type="button" onClick={() => acceptAll(language)}>
              {copy.accept}
            </button>
          </div>
        </div>
      </section>
    </>
  );
}
